// Tamil translations for Hindu and Tamil festival names

export const hinduFestivalTamil = {
  // January
  'Paush Purnima': 'பவுஷ் பூர்ணிமா',
  'Sankashti Chaturthi': 'சங்கஷ்டி சதுர்த்தி',
  'Makar Sankranti / Pongal': 'மகர சங்கராந்தி / பொங்கல்',
  'Mauni Amavasya': 'மவுனி அமாவாசை',
  'Vasant Panchami (Saraswati Puja)': 'வசந்த பஞ்சமி (சரஸ்வதி பூஜை)',
  'Ratha Saptami': 'ரத சப்தமி',
  'Bhishma Ashtami': 'பீஷ்ம அஷ்டமி',
  'Jaya Ekadashi': 'ஜெய ஏகாதசி',

  // February
  'Magha Purnima': 'மாக பூர்ணிமா',
  'Vijaya Ekadashi': 'விஜய ஏகாதசி',
  'Maha Shivaratri': 'மகா சிவராத்திரி',
  'Phalguna Amavasya': 'பால்குன அமாவாசை',
  'Amalaki Ekadashi': 'ஆமலகி ஏகாதசி',

  // March
  'Phalguna Purnima': 'பால்குன பூர்ணிமா',
  'Holika Dahan': 'ஹோலிகா தஹன்',
  'Holi (Dhulandi)': 'ஹோலி (தூலண்டி)',
  'Sheetala Ashtami': 'சீதளா அஷ்டமி',
  'Papmochani Ekadashi': 'பாப்மோசனி ஏகாதசி',
  'Chaitra Amavasya': 'சைத்ர அமாவாசை',
  'Chaitra Navratri / Ugadi / Gudi Padwa': 'சைத்ர நவராத்திரி / உகாதி / குடி பட்வா',
  'Gauri Puja / Gangaur': 'கௌரி பூஜை / கங்கூர்',
  'Rama Navami': 'ராம நவமி',
  'Kamada Ekadashi': 'காமதா ஏகாதசி',

  // April
  'Chaitra Purnima': 'சைத்ர பூர்ணிமா',
  'Hanuman Jayanti': 'ஹனுமான் ஜயந்தி',
  'Varuthini Ekadashi': 'வருத்தினி ஏகாதசி',
  'Vaishakha Amavasya': 'வைசாக அமாவாசை',
  'Akshaya Tritiya': 'அக்ஷய திருதியை',
  'Mohini Ekadashi': 'மோகினி ஏகாதசி',

  // May
  'Vaishakha Purnima (Buddha Purnima)': 'வைசாக பூர்ணிமா (புத்த பூர்ணிமா)',
  'Apara Ekadashi': 'அபரா ஏகாதசி',
  'Jyeshtha Amavasya (Shani Jayanti)': 'ஜேஷ்ட அமாவாசை (சனி ஜயந்தி)',
  'Adhik Maas Begins': 'அதிக மாதம் தொடக்கம்',
  'Padmini Ekadashi (Adhik)': 'பத்மினி ஏகாதசி (அதிக)',
  'Jyeshtha Purnima': 'ஜேஷ்ட பூர்ணிமா',

  // June
  'Parama Ekadashi (Adhik)': 'பரம ஏகாதசி (அதிக)',
  'Ashadha Amavasya (Adhik Maas Ends)': 'ஆஷாட அமாவாசை (அதிக மாதம் முடிவு)',
  'Nirjala Ekadashi': 'நிர்ஜல ஏகாதசி',
  'Ashadha Purnima (Vat Purnima)': 'ஆஷாட பூர்ணிமா (வட பூர்ணிமா)',

  // July
  'Yogini Ekadashi': 'யோகினி ஏகாதசி',
  'Shravana Amavasya': 'ஸ்ராவண அமாவாசை',
  'Jagannath Rath Yatra': 'ஜகன்னாத ரத யாத்திரை',
  'Devshayani Ekadashi (Chaturmas Begins)': 'தேவசயனி ஏகாதசி (சாதுர்மாஸ் தொடக்கம்)',
  'Shravana Purnima (Guru Purnima)': 'ஸ்ராவண பூர்ணிமா (குரு பூர்ணிமா)',

  // August
  'Kamika Ekadashi': 'காமிகா ஏகாதசி',
  'Bhadrapada Amavasya (Hariyali Amavasya)': 'பாத்ரபத அமாவாசை (ஹரியாலி அமாவாசை)',
  'Nag Panchami': 'நாக பஞ்சமி',
  'Varalakshmi Vratam': 'வரலக்ஷ்மி விரதம்',
  'Shravana Putrada Ekadashi': 'ஸ்ராவண புத்ரதா ஏகாதசி',
  'Bhadrapada Purnima (Raksha Bandhan)': 'பாத்ரபத பூர்ணிமா (ரக்ஷா பந்தன்)',

  // September
  'Janmashtami': 'ஜன்மாஷ்டமி',
  'Aja Ekadashi': 'அஜா ஏகாதசி',
  'Ashwin Amavasya (Bhadrapada Amavasya)': 'ஆஸ்வின் அமாவாசை (பாத்ரபத அமாவாசை)',
  'Ganesh Chaturthi': 'விநாயகர் சதுர்த்தி',
  'Parivartini Ekadashi': 'பரிவர்த்தினி ஏகாதசி',
  'Ashwin Purnima': 'ஆஸ்வின் பூர்ணிமா',
  'Pitru Paksha Begins': 'பித்ரு பக்ஷம் தொடக்கம்',

  // October
  'Indira Ekadashi': 'இந்திரா ஏகாதசி',
  'Mahalaya Amavasya (Pitru Paksha Ends)': 'மகாளய அமாவாசை (பித்ரு பக்ஷம் முடிவு)',
  'Sharad Navratri Begins': 'சரத் நவராத்திரி தொடக்கம்',
  'Dussehra (Vijayadashami)': 'தசரா (விஜயதசமி)',
  'Papankusha Ekadashi': 'பாபாங்குசா ஏகாதசி',
  'Sharad Purnima': 'சரத் பூர்ணிமா',
  'Karwa Chauth': 'கர்வா சௌத்',

  // November
  'Rama Ekadashi': 'ராம ஏகாதசி',
  'Dhanteras': 'தன்தேராஸ்',
  'Kartik Amavasya (Diwali)': 'கார்த்திக் அமாவாசை (தீபாவளி)',
  'Diwali (Lakshmi Puja)': 'தீபாவளி (லக்ஷ்மி பூஜை)',
  'Govardhan Puja': 'கோவர்தன் பூஜை',
  'Bhai Dooj': 'பாய் தூஜ்',
  'Chhath Puja': 'சாத் பூஜை',
  'Devutthana Ekadashi (Tulsi Vivah)': 'தேவுத்தான ஏகாதசி (துளசி விவாஹ்)',
  'Kartik Purnima': 'கார்த்திக் பூர்ணிமா',

  // December
  'Utpanna Ekadashi': 'உத்பன்ன ஏகாதசி',
  'Margashirsha Amavasya': 'மார்கழி அமாவாசை',
  'Gita Jayanti': 'கீதா ஜயந்தி',
  'Mokshada Ekadashi': 'மோக்ஷதா ஏகாதசி',
  'Margashirsha Purnima': 'மார்கழி பூர்ணிமா',
};

export const tamilFestivalTamil = {
  // January
  'Arudra Darshan (Thiruvathirai)': 'ஆருத்ரா தரிசனம் (திருவாதிரை)',
  'Bhogi Pandigai': 'போகி பண்டிகை',
  'Thai Pongal (Surya Pongal)': 'தைப் பொங்கல் (சூரிய பொங்கல்)',
  'Mattu Pongal': 'மாட்டுப் பொங்கல்',
  'Kaanum Pongal / Thiruvalluvar Day': 'காணும் பொங்கல் / திருவள்ளுவர் தினம்',
  'Uzhavar Thirunal (Farmers\' Day)': 'உழவர் திருநாள்',
  'Thai Amavasai': 'தை அமாவாசை',
  'Ratha Saptami': 'ரத சப்தமி',

  // February
  'Thaipusam (Thai Poosam)': 'தைப்பூசம் (தை பூசம்)',
  'Maha Shivaratri': 'மகா சிவராத்திரி',

  // March
  'Masi Magam': 'மாசி மகம்',
  'Karadaiyan Nombu': 'காரடையான் நோன்பு',
  'Rama Navami': 'ராம நவமி',

  // April
  'Panguni Uthiram': 'பங்குனி உத்திரம்',
  'Tamil New Year (Puthandu)': 'தமிழ் புத்தாண்டு (புத்தாண்டு)',
  'Akshaya Tritiyai': 'அக்ஷய திருதியை',
  'Chithirai Thiruvizha Begins': 'சித்திரை திருவிழா தொடக்கம்',
  'Meenakshi Thirukalyanam': 'மீனாட்சி திருக்கல்யாணம்',

  // May
  'Chitra Pournami': 'சித்ரா பௌர்ணமி',
  'Vaikasi Visakam': 'வைகாசி விசாகம்',

  // June
  'Aani Thirumanjanam': 'ஆனி திருமஞ்சனம்',
  'Aani Pournami': 'ஆனி பௌர்ணமி',

  // July
  'Aadi Amavasai (Early)': 'ஆடி அமாவாசை (முன்கூட்டி)',
  'Aadi Month Begins (Aadi Pirappu)': 'ஆடி மாதம் தொடக்கம் (ஆடிப் பிறப்பு)',
  'Aadi Chevvai': 'ஆடி செவ்வாய்',
  'Aadi Kiruthigai': 'ஆடி கிருத்திகை',
  'Aadi Pournami': 'ஆடி பௌர்ணமி',

  // August
  'Aadi Perukku': 'ஆடிப் பெருக்கு',
  'Aadi Amavasai': 'ஆடி அமாவாசை',
  'Andal Jayanthi': 'ஆண்டாள் ஜயந்தி',
  'Avani Avittam (Rigveda)': 'ஆவணி அவிட்டம் (ரிக்வேதம்)',
  'Avani Avittam (Yajurveda)': 'ஆவணி அவிட்டம் (யஜுர்வேதம்)',
  'Varalakshmi Vratam / Gayathri Japam': 'வரலக்ஷ்மி விரதம் / காயத்ரி ஜபம்',

  // September
  'Gokulashtami (Krishna Jayanthi)': 'கோகுலாஷ்டமி (கிருஷ்ண ஜயந்தி)',
  'Vinayagar Chaturthi (Pillaiyar Chaturthi)': 'விநாயகர் சதுர்த்தி (பிள்ளையார் சதுர்த்தி)',

  // October
  'Mahalaya Amavasai': 'மகாளய அமாவாசை',
  'Navaratri Begins': 'நவராத்திரி தொடக்கம்',
  'Ayudha Pooja / Saraswati Pooja / Vijayadashami': 'ஆயுத பூஜை / சரஸ்வதி பூஜை / விஜயதசமி',
  'Vidyarambham': 'வித்யாரம்பம்',

  // November
  'Deepavali (Lakshmi Puja)': 'தீபாவளி (லக்ஷ்மி பூஜை)',
  'Skanda Sashti Begins': 'ஸ்கந்த சஷ்டி தொடக்கம்',
  'Soora Samharam': 'சூர சம்ஹாரம்',
  'Karthigai Deepam': 'கார்த்திகை தீபம்',

  // December
  'Subrahmanya Sashti': 'சுப்ரமண்ய சஷ்டி',
  'Vaikunta Ekadashi': 'வைகுண்ட ஏகாதசி',
  'Arudra Darshan (Thiruvathirai)': 'ஆருத்ரா தரிசனம் (திருவாதிரை)',
};
